<!-- Modal vue -->

<template lang="pug">
div.download-container(v-if="download !== undefined")
    div
        div.description
            p
                | Please select the differents options that you would like to include or exclude in your download.<br>
                | An archive will be generated to be used locally on your computer.

        div.group-container
            div.group(v-for="(group) in this.inputs")
                div.option(v-for="(input, key) in group.items")
                    div.radio-container(v-if="input.type=='radio'", v-for="(radio) in input.values", v-bind:class="{'selected':input.selected}", v-on:click="updateRadio(input, radio)")
                        //input(type="radio", v-model="input.value", v-bind:name="key", v-bind:value="radio.value")
                        span.radio(v-bind:class="{'selected':(input.value==radio.value)}")
                        label {{radio.label}}
                    div.checkbox-container(v-if="input.type=='checkbox'", v-on:click="updateCheckbox(input)")
                        span.checkbox(v-bind:class="{'selected':input.selected}")
                        label {{input.label}}

        p.error(v-if="responseLogs")
            strong {{responseLogs}}

    div.action
        //div.button.confirm(v-on:click.once="validate")
        div.button.confirm(v-on:click="validate", v-bind:class="{'disabled':options==''}")
            p Download
</template>

<script>
import Icon from '../common/Icon.vue'
import actionManager from '../../actions';

export default {

    // settings	the modal configuration (ie. app.state.modal)
    props: {
        download: { type: Object },
    },

    components: {
        Icon
    },

    data() {
        return {
            default: [],
            responseLogs: null,
            inputs: [
                {
                    group: "Assets",
                    items: {
                        assets: {
                            type: "radio",
                            value: "",
                            values: [
                                {
                                    label: "No assets",
                                    value: "",
                                    selected: true,
                                },
                                {
                                    label: "All assets",
                                    value: "assets",
                                    selected: false,
                                },
                                {
                                    label: "Static assets only",
                                    value: "static-only",
                                    selected: false,
                                }
                            ]
                        }
                    }
                },
                {
                    group: "Core",
                    items: {
                        dataproject: {
                            label: "Data project",
                            type: "checkbox",
                            selected: true,
                        },
                        player: {
                            type: "checkbox",
                            label: "Player",
                            selected: true,
                        }
                    //     logs: {
                    //         type: "checkbox",
                    //         label: "Logs",
                    //         selected: false,
                    //     }
                    }
                }
            ],
        }
    },

    created: function() {
    },

    computed: {
        options: function() {
            const keys = [];
            for (let i=0; i <this.inputs.length; i++) {
                for (let key in this.inputs[i].items) {
                    const input = this.inputs[i].items[key];
                    if (input.type === "checkbox" && input.selected) keys.push(key);
                    if (input.type === "radio" && input.value) {
                        if (input.value === key) keys.push(key);
                        else keys.push(key,input.value);
                    }
                }
            }
            return keys.join(",");
        },
    },

    methods: {
        updateRadio: function(input, radio) {
            if (input.type === "radio") input.value = radio.value;
        },

        updateCheckbox: function(input) {
            if (input.type === "checkbox") input.selected = !input.selected;
        },

        validate: function() {
            if (!this.options) return;

            actionManager.trigger('project:download', {
                experience: this.download.experienceName,
                options: this.options,
                nextAction:'main:modal:closeModal', 
            });
        }

    }
}
</script>

<style lang="stylus" scoped>
.download-container
    .group-container
        display: flex
        flex-direction: row
        margin: 20px
        padding: 20px
        border-radius: 20px
        background-color: var(--addElementColor)

        .group
            display: flex
            flex-direction: column
            flex-grow: 1
            gap: 10px

            .radio-container
                display: flex
                flex-direction: row
                flex-wrap: nowrap
                align-items: center
                gap: 10px
                margin-bottom: 10px

                .radio
                    display: inline-block
                    width: 30px
                    height: 30px
                    border-radius: 15px
                    background-color: var(--inputValue)

                    &.selected:after
                        content: ""
                        display: inline-block
                        width: 20px
                        height: 20px
                        border-radius: 10px
                        background-color: var(--bgColor)
                        position: relative;
                        left: 0
                        top: 5px

            label
                // position: relative
                // top: -13px
                // left: 42px
                text-transform: capitalize
                white-space: nowrap
                text-overflow: ellipsis
                overflow: hidden

            .checkbox-container
                display: flex
                flex-direction: row
                align-items: center
                gap: 10px
            
                .checkbox
                    height: 30px !important
                    margin-top: 0 !important

    .action
        .button
            font-family: 'DinBold'
            display: inline-block
            text-align: center
            color: white
            background-color:var(--selectedColor)
            width: 160px
            height: 20px
            padding: 8px 10px
            border: none
            border-radius: 40px
            cursor: pointer
            font-size: 16px
            margin: 4px
            opacity: 0.5
            transition: linear all .1s !important

            &.nofocus
                opacity: 0.3

            &.button:hover
                opacity: 1

            &.disabled
                opacity: 0.2 !important
                cursor: inherit
            p
                margin: 0
</style>